<template>
  <div class="menu">
    <ul>
      <li><a :class="{ active : mobile_menu == 'games'}" @click="change('games')" href="javascript:;">Casino Oyunları</a></li>
      <li><a :class="{ active : mobile_menu == 'fav'}" @click="change('fav')" href="javascript:;">Favorilerim</a></li>
    </ul>
  </div>
</template>

<script>
  export default{
    props:['mobile_menu'],
    methods:{
      change(menu){
        if(menu == 'fav'){
          this.$store.dispatch('slot/changeCategory', ['fav'])
        }else{
          this.$store.dispatch('slot/changeCategory', ['all'])
        }
        this.$emit('menuChange', menu);
      }
    }
  }
</script>